import { cookiesName, localStorageCookieConsent } from '@components/CookiesModal/config';

const dashboardTrackingStorageKey = 'pmu-infocentre:dashboard-tracked-partner-id';

const hasAnalyticsConsent = (): boolean => {
  const cookieData = globalThis.localStorage.getItem(localStorageCookieConsent);

  if (!cookieData) {
    return false;
  }

  try {
    const parsedCookieData: unknown = JSON.parse(cookieData);

    if (parsedCookieData === null || typeof parsedCookieData !== 'object') {
      return false;
    }

    const cookieConsent = parsedCookieData as Record<string, unknown>;

    return cookieConsent[cookiesName.analytics] === true;
  } catch (error) {
    // eslint-disable-next-line no-console
    console.warn('[partnerDashboardTracking] Invalid cookie consent payload', error);

    return false;
  }
};

const isPartnerIdAlreadyTracked = (partnerId: string): boolean =>
  globalThis.localStorage.getItem(dashboardTrackingStorageKey) === partnerId;

const shouldTrackDashboard = (partnerId: string): boolean => {
  if (!hasAnalyticsConsent()) {
    return false;
  }

  if (isPartnerIdAlreadyTracked(partnerId)) {
    return false;
  }

  return true;
};

const markPartnerIdAsTracked = (partnerId: string): void =>
  globalThis.localStorage.setItem(dashboardTrackingStorageKey, partnerId);

export { markPartnerIdAsTracked, shouldTrackDashboard, dashboardTrackingStorageKey };
